import { Component, inject } from '@angular/core';
import { ReasonGroupService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ReasonGroupCreateDto,
  ReasonGroupDto,
  ReasonGroupExcelDownloadDto,
  ReasonGroupUpdateDto,
} from '../proxy/general/dtos/reason-group';
import { REASONGROUP_CONFIG, REASONGROUP_FIELDS } from './reason-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-reason-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ReasonGroupService, ConfirmationService],
  templateUrl: './reason-group.html',
  styleUrl: './reason-group.scss',
})
export class ReasonGroup extends BaseCrudComponent<
  ReasonGroupDto,
  ReasonGroupCreateDto,
  ReasonGroupUpdateDto,
  ReasonGroupExcelDownloadDto
> {
  service = inject(ReasonGroupService);
  config = REASONGROUP_CONFIG;
  fields = REASONGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: ReasonGroupDto): ReasonGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ReasonGroup';
  }
}
